import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion-v2";

export function ToolsFaqAccordion() {
  return (
    <Accordion type="single" collapsible className="w-full max-w-2xl space-y-4">
      <AccordionItem value="item-1" className="overflow-hidden rounded-lg">
        <AccordionTrigger number="1">
          I created a link but I would like to modify it, how can I do that?
        </AccordionTrigger>
        <AccordionContent>
          Links generated by our public tools can not be modified. However, you
          can contact us to prove ownership of the link and we will transfer the
          link to your account and you can change it using our dashboard.
        </AccordionContent>
      </AccordionItem>
      <AccordionItem value="item-2" className="overflow-hidden rounded-lg">
        <AccordionTrigger number="2">
          How can I enable analytics on my link?
        </AccordionTrigger>
        <AccordionContent>
          You need to contact us to prove ownership of the link and we will
          transfer the link to your account and you can view analytics in our
          dashboard.
        </AccordionContent>
      </AccordionItem>
      <AccordionItem value="item-3" className="overflow-hidden rounded-lg">
        <AccordionTrigger number="3">Is it free to use?</AccordionTrigger>
        <AccordionContent>
          Yes! our public tools are free to use, however if you need analytics
          and other features, you can contact us to purchase a plan.
        </AccordionContent>
      </AccordionItem>
      <AccordionItem value="item-4" className="overflow-hidden rounded-lg">
        <AccordionTrigger number="4">
          How can I report malicious links?
        </AccordionTrigger>
        <AccordionContent>
          Send an email to{" "}
          <a href="mailto:contact@smartlink.mk" className="underline">
            contact@smartlink.mk
          </a>
        </AccordionContent>
      </AccordionItem>
      <AccordionItem value="item-5" className="overflow-hidden rounded-lg">
        <AccordionTrigger number="5">
          Where can I use the link?
        </AccordionTrigger>
        <AccordionContent>
          You can use the link on your website, social media, or anywhere else
          you want.
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
